module.exports = __webpack_public_path__ + "static/media/NotoSansJP-Regular.dd4fa7df.ttf";